import { defaultApiState } from '@/store/types/general.types';
import { ShortCourseCheckoutState } from './short-course-checkout.types';

export const shortCourseCheckoutState: ShortCourseCheckoutState = {
  apiState: {
    placeholderApi: defaultApiState
  },
  selectedPackages: [],
  selectedSeats: 0,
  isLastStep: false
};

// Extend with other checkout page states
